<app-modal
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onHidden)="onHidden()"
  [modalTitle]="
    translationService.getCurrentLanguage()['share-link'] || 'PARTILHAR MAPA'
  "
  width="30rem"
  height="12.8rem"
>
  <ng-template modalContent>
    <form
      *ngIf="!link"
      class="form-register"
      [formGroup]="formGroup"
      (ngSubmit)="onSubmit($event)"
    >
      <div class="fields-container">
        <div class="field-set">
          <label label
            >{{
              translationService.getCurrentLanguage()["map-name"] ||
                "Nome do Mapa"
            }}*</label
          >

          <app-input-box
            formControlName="name"
            [maxLength]="nameMaxLength"
            [showErrorEnabled]="false"
          ></app-input-box>
        </div>
      </div>

      <div class="actions-bottom">
        <app-button
          type="submit"
          buttonType="primary"
          styleType="contained"
          [text]="
            translationService.getCurrentLanguage()['share'] || 'Partilhar'
          "
          [disabled]="formGroup.invalid"
        ></app-button>

        <app-button
          buttonType="normal"
          styleType="contained"
          [text]="
            translationService.getCurrentLanguage()['cancel'] || 'Cancelar'
          "
          (click)="onBtnCancelClick()"
        ></app-button>
      </div>
    </form>

    <div *ngIf="!!link" class="link-container">
      <div class="link-content" [title]="link">
        {{ link }}
      </div>

      <div class="btn-item" #btnCopyEl>
        <app-button
          buttonType="normal"
          styleType="text"
          shapeType="circle"
          icon="assets/icons/clipboard-regular.svg"
          (click)="onBtnCopyClick()"
        ></app-button>

        <app-tooltip
          [target]="btnCopyEl"
          verticalAlignment="top"
          horizontalAlignment="center"
        >
          {{ translationService.getCurrentLanguage().copy }}
        </app-tooltip>
      </div>
    </div>
  </ng-template>
</app-modal>
